import NavBarWithFooterLayout from "../../layouts/navBarWithFooter.layout";
import Page from "./page.products.page";

const ProductsLayout = () => {
  return (
    <NavBarWithFooterLayout>
      <Page />
    </NavBarWithFooterLayout>
  );
};

export default ProductsLayout;
